import { ReactComponent as LoadingIcon } from '../images/icons/loading.svg';

const LoadingBlock = () => {

    return (
        
        <div className="loading-block loading-icon-wrapper" style={{ textAlign: 'center', padding: '4rem', width: '100%' }}>
            <LoadingIcon />            
        </div>
    );
};

export default LoadingBlock;